import {Transform, Type} from 'class-transformer';

import {User} from '../user';
import {GroupUserPermissions} from './groupUserPermissions';

/**
 * Group users with all group specific data
 * */
export class GroupUser {
  /**
   * User class
   * */
  @Type(() => User)
  user: User = null;

  /**
   * Public information of user in this group
   * */
  @Type(() => GroupUserPublic)
  public: GroupUserPublic = new GroupUserPublic();

  /**
   * Private information of current user in this group<br>
   * It must be empty if current user is not same, must be removed on server.<br>
   * <br>
   * For future needs, not implemented yet.
   * */
  @Type(() => GroupUserPrivate)
  private: GroupUserPrivate = new GroupUserPrivate();

  /**
   * List of permissions for this group for this user
   * */
  @Type(() => String)
  @Transform(({value}) => new GroupUserPermissions(...value))
  permissions: GroupUserPermissions = new GroupUserPermissions();
}

/**
 * Public information of user in this group
 * */
export class GroupUserPublic {
  /**
   * Custom title of user in this group
   *
   * @example ответственный
   * */
  title: string;

  /**
   * Color of title, process same as AppColorList
   * */
  titleColor? = 'alert';

  /**
   * Color of user, process same as AppColorList
   * */
  userColor? = 'text';
}

/**
 * Private information of current user in this group<br>
 * It must be empty if current user is not same, must be removed on server.<br>
 * <br>
 * For future needs, not implemented yet.
 * */
export class GroupUserPrivate {
  notificationSettings: null;
  folders: [];
}
